/**
 * Video.js plugin "downloadOption"
 *
 * The plugin offers a download option.
 *
 * @function downloadOption
 * @param
 */

const pluginDownloadOption = videojs => {
  videojs.registerPlugin('downloadOption', function (player, config) {
    player.ready(() => {

      if (
        (
          (!config.downloadOption || config.downloadOption === 'false') &&
          (!player.el_.dataset.downloadOption || player.el_.dataset.downloadOption === 'false')
        ) ||
        (player.el_.dataset.downloadOption === 'false') || 
          player.usesExternalTech
      ) return;

      // Prevent doubled rendering
      if (player.el_.querySelector('.vjs-download-option')) return;

      const downloadOption = config.downloadOption || config.downloadOption !== 'false' || player.el_.dataset.downloadOption !== 'false' ? player.el_.dataset.downloadOption : false; 
      let controlBarButton;

      const createControlbarButton = () => {
        controlBarButton = player.controlBar.addChild('button');
        controlBarButton.controlText(player.localize('Download'));
        controlBarButton.el_.classList.add('vjs-download-option');
        controlBarButton.on('click', downloadHandler);
      };

      const getFilePath = function() {
        return typeof downloadOption === 'string' && downloadOption !== 'true' ? downloadOption : player.currentSrc();
      }

      const downloadHandler = function() {
        const path = getFilePath();

        // Since no links can be added to `player.controlBar` a hidden link is created that gets clicked when the `controlBarButton` is used.

        let hiddenLink;

        if (!this.el_.nextSibling || !this.el_.nextSibling.classList.contains('vjs-download-option-link')) {
          const link = document.createElement('a');
          link.className = 'vjs-download-option-link';
          link.setAttribute('aria-hidden', 'true');
          link.setAttribute('aria-disabled', 'true');
          link.setAttribute('target', '_blank');
          link.setAttribute('rel', 'noopener noreferrer');
          link.style.display = 'none';
          this.el_.parentNode.insertBefore(
            link,
            this.el_.nextSibling
          );
        }

        hiddenLink = this.el_.nextSibling;
        hiddenLink.setAttribute('download', path.split('/').pop());
        hiddenLink.setAttribute('href', path);
        hiddenLink.click();

        player.trigger('download');
      }

      createControlbarButton();

      player.on('loadstart', () => {
        // Update tooltip text to include file name
        const path = getFilePath();
        controlBarButton.controlText(player.localize(`Download "${path.split('/').pop()}"`))
      });
    });
  });
};

export { pluginDownloadOption };
